const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
    api: "https://uongbi-api.cgis.asia/",
  },  
  production: {
      api: "https://uongbi-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
